import { CheckoutStepType } from 'haba-featurelibs/checkout/root';

export const CheckoutStepsConfig = {
  checkout: {
    steps: [
      {
        id: 'login',
        name: 'habaCheckoutProgress.login',
        routeName: 'checkoutLogin',
        type: [],
      },
      {
        id: 'billingAddress',
        name: 'habaCheckoutProgress.customerData',
        routeName: 'checkoutBillingAddress',
        type: [CheckoutStepType.BILLING_ADDRESS],
      },

      {
        id: 'paymentDetails',
        name: 'habaCheckoutProgress.paymentDetails',
        routeName: 'checkoutPaymentDetails',
        type: [CheckoutStepType.PAYMENT_DETAILS],
      },
      {
        id: 'reviewOrder',
        name: 'habaCheckoutProgress.reviewOrder',
        routeName: 'checkoutReviewOrder',
        type: [CheckoutStepType.REVIEW_ORDER],
      },
    ],
  },
};
